import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CircularProgress from "@mui/material/CircularProgress";
import { IfPermission } from "../../auth/IfPermission";
import type { PasswordCellState } from "./SiteDataGrid";

export function PasswordCell(props: { state: PasswordCellState; onToggle: () => void }) {
  const { state, onToggle } = props;
  const isRevealed = state.kind === "revealed";
  const isLoading = state.kind === "loading";
  const isError = state.kind === "error";
  const buttonTitle = isRevealed ? "Скрыть пароль" : "Показать пароль";
  const shownText = isError ? state.message : "•••";
  const passwordText = isRevealed ? state.value : shownText;
  let toggleIcon = <VisibilityIcon fontSize="small" />;
  if (isLoading) {
    toggleIcon = <CircularProgress size={16} />;
  } else if (isRevealed) {
    toggleIcon = <VisibilityOffIcon fontSize="small" />;
  }
  return (
    <Box display="inline-flex" alignItems="center" gap={1}>
      <Box component="span" sx={{ fontFamily: "monospace", color: isError ? "error.main" : undefined }}>
        {passwordText}
      </Box>
      <IfPermission permission="sites.credentials.reveal">
        <Tooltip title={buttonTitle}>
          <span>
            <IconButton size="small" onClick={onToggle} disabled={isLoading} aria-label={buttonTitle}>
              {toggleIcon}
            </IconButton>
          </span>
        </Tooltip>
      </IfPermission>
    </Box>
  );
}
